import { HttpsCallable, HttpsCallableOptions, httpsCallableFromURL } from 'firebase/functions'
import { firebase_functions } from '../config/firebaseConfig'

const HOSTING_ORIGIN =
  import.meta.env.VITE_ENVIRONMENT === 'production'
    ? 'https://greenchart-membership-portal-prod.web.app'
    : 'https://greenchart-membership-portal.web.app'

/** Same-origin when served from Hosting (rewrites are CORS-free); absolute dev/prod Hosting origin from localhost. */
export const API_BASE =
  typeof window !== 'undefined' && window.location.hostname !== 'localhost'
    ? window.location.origin
    : HOSTING_ORIGIN

/**
 * Strangler-facade callable reference. Calls through /api/<name>; the Hosting rewrite decides
 * whether the old Cloud Function or gc-api serves it (server-side flip, migration Phase 2).
 */
export function callableRef<Req = unknown, Res = unknown>(
  name: string,
  options?: HttpsCallableOptions
): HttpsCallable<Req, Res> {
  return httpsCallableFromURL<Req, Res>(firebase_functions, API_BASE + '/api/' + name, options)
}
